var map = {
	"./black/qiangchai.png": "AwBr",
	"./blue/qiangchai.png": "IxrW",
	"./white/qiangchai.png": "pVyT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TiCl";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/qiangchai\.png$
// module id = TiCl
// module chunks = 24